import React, { FC, useState } from 'react';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import LaunchOutlined from '@material-ui/icons/LaunchOutlined';
import { useTranslation } from 'react-i18next';

import { ContentEmailSpecFragment } from 'api';
import { PreviewDialog } from './index';

interface Props {
  contentEmail: ContentEmailSpecFragment;
}

const SentActions: FC<Props> = ({ contentEmail }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  function onClickPreview() {
    setOpen(true);
  }

  function renderPreviewIcon() {
    return (
      <Grid item>
        <Tooltip placement="top" title={t('')}>
          <IconButton onClick={onClickPreview}>
            <LaunchOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center" justify="center">
      {renderPreviewIcon()}
      <PreviewDialog open={open} onClose={() => setOpen(false)} values={contentEmail} />
    </Grid>
  );
};

export default SentActions;
